import { useEffect, useState } from "react";
import { isEqual } from "lodash";
import { useSelector } from "react-redux";
import { isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";

import { useDictionary } from "hooks";
import { formSelectors } from "store/selectors";

import { getTruncatedAndFullLabels } from "../utils";

export const useTruncatedAndFullLabels = ({ formElementId, optionId, maxLength, formElements = [] }) => {
	const dictionary = useDictionary("ruleBuilder");
	const { formElements: savedFormElements } = useSelector(formSelectors.content);
	const [ labels, setLabels ] = useState({ truncatedLabel: "", fullLabel: "", isTruncated: false });

	useEffect(() => {
		let isMounted = true;
		const doIt = async () => {
			const updatedLabels = await getTruncatedAndFullLabels({
				formElements: isNonEmptyArray(formElements) ? formElements : savedFormElements,
				formElementId,
				maxLength,
				optionId,
				dictionary
			});

			if (!isEqual(labels, updatedLabels) && isMounted) {
				setLabels(updatedLabels);
			}
		};

		doIt();
		return () => {
			isMounted = false;
		} 
	}, [
		formElementId,
		maxLength,
		optionId,
	]);

	return labels;
};
